import type { ILink, IPagePath } from "@contentful-api/types/contentful";
import { isUndefined } from "lodash-es";

export const linkTypeGuard = (link: ILink | IPagePath): link is ILink =>
    !isUndefined((link as ILink).fields.internalLink);
